module.exports = "html{box-sizing:border-box}*{background:transparent;border:0;font-family:inherit;font-size:inherit;list-style:none;margin:0;padding:0;text-align:inherit}*,:after,:before{box-sizing:inherit}audio,embed,iframe,img,object,video{height:auto;max-width:100%}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-base/theme/reset.local.scss
// module id = 6
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38